import React from "react";
import linkedinIcon from "../assets/linkedin-icon.svg";

const founders = [
  {
    name: "Maximilian Bunte",
    role: "Co-Founder · Strategy & Growth",
    image: "/assets/MB.jpeg",
    overlayText: "Experte für Hospitality, Management Consulting und Qualitätsprozesse.",
    linkedin: "https://linkedin.com/in/maximilian-bunte-975296157",
    description: `  B.BA. International Hospitality Management (Hotelschool The Hague)\n MSc. Strategic Management (Rotterdam School of Management)
    
      10+ Jahre internationale Erfahrung in Hospitality Management & Gastronomie, Project Management & Unternehmensberatung
    
      Fokus auf Strategie, Prozesse und operative Umsetzung

      Verständnis für Unternehmens- und Talentbedürfnisse aus eigener Praxis
`,
  },
 /* {
    name: "Constantin Bunte",
    role: "Co-Founder · Finance & Investments",
    image: "/assets/CB.jpeg",
    overlayText: "Finanzstratege mit Leidenschaft für KMUs und skalierbare Modelle.",
    linkedin: "https://linkedin.com/in/constantin-bunte-3181631b4",
    description: `Constantin Bunte ist Co-Founder und Co-CEO von Qlance. Mit fundierter Erfahrung in Management Consulting, M&A und Private Equity bringt er strategisches Gespür, Struktur und unternehmerisches Denken in die Skalierung von Unternehmen – insbesondere im deutschen Mittelstand.
Er hat Projekte in unterschiedlichsten Branchen wie Healthcare, Software, Maschinenbau und Industrie begleitet. Seine analytische, lösungsorientierte Arbeitsweise ist geprägt von einem klaren Fokus auf Effizienz und messbare Ergebnisse. Dabei gelingt es ihm, sich schnell in komplexe Geschäftsmodelle hineinzudenken und datenbasiert wirtschaftliche Potenziale zu realisieren.
Constantin hält einen Bachelor in International Management (WHU – Otto Beisheim School of Management) sowie einen Master in Finance (Nova School of Business and Economics).`,
  },
  {
    name: "Moritz Feklist",
    role: "Co-Founder · Operations & Produkt",
    image: "/assets/MF4.png",
    overlayText: "Experte für nachhaltige Produktentwicklung & Green Finance.",
    linkedin: "https://linkedin.com/in/moritz-feklist-b8ba6b117",
    description: `Moritz Feklist ist Co-Founder und Co-CEO von Qlance. Mit über acht Jahren Erfahrung in Investment Banking, Wagniskapital und strategischer Beratung bringt er tiefes Finanzierungs-Know-how und ein geschärftes Gespür für Wachstumschancen in das Gründerteam ein.
Er hat Unternehmen und Gründerteams durch komplexe M&A- und Fundraising-Prozesse begleitet und dabei über 20 Millionen USD an Kapital strukturiert. Seine Stärken liegen in analytischer Tiefe, Kapitalmarktexpertise und einer ausgeprägten Umsetzungsorientierung – stets mit dem Fokus, wirtschaftliche Potenziale strategisch zu erschließen.
Moritz hält einen Bachelor in International Management (WHU – Otto Beisheim School of Management) sowie einen Master in Finance (Nova School of Business and Economics).`,
  },
  {
    name: "Michael Bunte",
    role:" Co-Founder · Senior Adviser",
    image: "/assets/MBV.png",
    overlayText: "Führungserfahrung im Mittelstand, Lean-Management-Profi und Experte für industrielle Exzellenz.",
    linkedin:"https://www.linkedin.com/in/michael-bunte-63924743/",
    description: `Michael Bunte ist Co-Founder und Senior Advisor bei Qlance. Als langjähriger Geschäftsführer im deutschen Mittelstand bringt er umfassende Führungserfahrung und tiefes operatives Know-how in die Projektarbeit ein. Seine Schwerpunkte liegen in Operational Excellence, Lean Management und der Optimierung von Geschäftsprozessen – insbesondere in der Automobilindustrie. 
Er leitete funktionsübergreifende Teams, verantwortete unternehmerische Transformationen und kennt die Herausforderungen mittelständischer Unternehmen aus erster Hand. Bei Qlance begleitet er Projekte als erfahrener Sparringspartner – mit einem klaren Blick für das Machbare, einem strukturierten Vorgehen und einem tiefen Verständnis industrieller Wertschöpfung. Besonders im Zusa
`
`Maximilian Bunte ist Co-Founder und Co-CEO von Qlance. Mit über einem Jahrzehnt Erfahrung in der internationalen Luxushotellerie, Unternehmensberatung und dem Quick-Service-Restaurant Business Sector verbindet er operative Exzellenz mit strategischem Denken. Seine Schwerpunkte liegen in Kundenorientierung, Prozesseffizienz, Konzeptentwicklung sowie der Umsetzung innovativer Lösungen im Projekt- und Freelancer-Management.
Er sammelte internationale Berufserfahrung in Europa und dem Nahen Osten – sowohl in Konzernen als auch in agilen Start-up-Umfeldern – und arbeitet mit besonderem Fokus an der Schnittstelle von Unternehmertum, Innovation und agiler Transformation.
Maximilian hält einen Bachelor in International Hospitality Management (Hotelschool The Hague) sowie einen Master in Strategic Management (Rotterdam School of Management, Erasmus University).`
  } */
];

const FounderTeam = () => {
  return (
    <section className="founder-team-section" id="founder-team">
      <h2 className="founder-team-title">
        Ihr <span className="highlight">Ansprechpartner </span>
      </h2>
      <p className="founder-team-subtitle">
        Unser Gründerteam bringt jahrelange Expertise aus Beratung, Finanzwelt und Operations in Ihre Projekte – für innovative Lösungen und skillbasiertes Matching. Gemeinsam verfolgen wir eine klare Mission: Talente und Unternehmen smarter, schneller und besser zusammenzubringen.
      </p>

      {founders.map((founder, index) => (
        <div className="founder-row" key={index}>
          <div className="founder-img-wrapper">
            <a
              href={founder.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="founder-image-link"
            >
              <div className="founder-image-overlay-container">
                <img src={founder.image} alt={founder.name} className="founder-image" />
                <div className="founder-overlay">
                  <p>{founder.overlayText}</p>
                </div>
              </div>
            </a>
          </div>
          <div className="founder-info">
            <h3 className="founder-name">{founder.name}</h3>
            <p className="founder-role">{founder.role}</p>
            <p className="founder-description">{founder.description}</p>
          {/*   <a
              href={founder.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="founder-linkedin-button"
            >
              <img src={linkedinIcon} alt="LinkedIn" />
            </a> */}
          </div>
        </div>
      ))}
    </section>
  );
};

export default FounderTeam;
